import { render, staticRenderFns } from "./integartionConfig.vue?vue&type=template&id=f71e0d32&scoped=true"
import script from "./integartionConfig.vue?vue&type=script&lang=js"
export * from "./integartionConfig.vue?vue&type=script&lang=js"
import style0 from "./integartionConfig.vue?vue&type=style&index=0&id=f71e0d32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71e0d32",
  null
  
)

export default component.exports